import { CSSProperties } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Flex from '../Flex';

export interface LoadingSpinProps {
  size?: number | string;
  text?: string;
  fail?: boolean;
  failText?: string | undefined;
  fillHeight?: boolean;
  className?: string;
  direction?: CSSProperties['flexDirection'];
  containerClassName?: string;
}

export function LoadingSpin({
  size = 24,
  text = undefined,
  className = undefined,
  fail = false,
  failText = undefined,
  fillHeight = false,
  direction = 'column' as CSSProperties['flexDirection']
}: LoadingSpinProps) {

  const [t] = useTranslation(['common']);

  if (text === undefined) {
    text = t('common:labels.loading-data');
  }

  if (!failText) {
    failText = t('common:errors.fetch-data');
  }

  return (
    <Flex className={'w-full ' + (fillHeight ? 'h-full' : '')} justify="center" align="center">
      <Flex
        inlineFlex
        direction={direction}
        className={className}>
        {!fail ?
          <>
            <div className="mx-auto inline-flex items-center justify-center pb-2"><LoadingOutlined style={{ fontSize: size }} spin /></div>
            {text && <b>{text}</b>}
          </>
          :
          failText && <b>{failText}</b>
        }
      </Flex>
    </Flex >
  );
}

export default LoadingSpin;
